/**
 * deselectRow
 *
 * Removes a row from Valtio selection state using swap-and-pop for O(1) removal.
 * Shared by ArRowActions, ArRowContextMenu, and ArBundleHeaderRow.
 */

import type { ArRowId } from '#types/System.Artifacts.types';
import type { SelectionState } from '../state/createArTableState';

function deselectRow(selection: SelectionState, rowId: ArRowId): void {
  if (selection.selectedRows[rowId] !== true) return;

  const idx = selection.selectedRowIndexById[rowId];
  if (idx !== undefined) {
    const lastIndex = selection.selectedRowIds.length - 1;
    const lastRowId = selection.selectedRowIds[lastIndex] as ArRowId;
    if (idx !== lastIndex) {
      selection.selectedRowIds[idx] = lastRowId;
      selection.selectedRowIndexById[lastRowId] = idx;
    }
    selection.selectedRowIds.pop();
  }
  delete selection.selectedRowIndexById[rowId];
  delete selection.selectedRows[rowId];
  selection.selectedCount--;
  if (selection.lastClickedRowId === rowId) {
    selection.lastClickedRowId = null;
  }
}

export { deselectRow };
